// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SkeletonContract = contract({
  name: "Skeleton",
  description: "Loading placeholder for content whose shape you know. Set width/height via className to mimic the real content (e.g. \"h-4 w-32\"). Not a spinner — use it where the real thing will drop in.",
  import: "@gradeui/ui",
  aliases: ["placeholder","shimmer","loader","loading state","redacted","redacted placeholder","shimmer placeholder","content placeholder","lottie placeholder"],
  element: "div",
  composesWith: ["Card","Avatar (inside a Skeleton for avatar loading)","any layout"],
  styleDefaults: {"Skeleton":"animate-pulse rounded-md bg-muted"},
  props: {
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
      description: "required in practice; supply width/height utilities",
  },
  },
});
